export default __webpack_public_path__ + "static/media/background.431203b0.png";